import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center p-4 text-center">
          <h5 className="text-danger mb-3">Ocurrio un error inesperado</h5>
          <p className="text-muted mb-3">
            {this.state.error?.message || "Error desconocido"}
          </p>
          <button
            type="button"
            className="btn bg-primary text-white px-4"
            onClick={this.handleReset}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
